import { render, staticRenderFns } from "./DuplicateQuestion.vue?vue&type=template&id=f020c9dc&scoped=true"
import script from "./DuplicateQuestion.vue?vue&type=script&lang=js"
export * from "./DuplicateQuestion.vue?vue&type=script&lang=js"
import style0 from "./DuplicateQuestion.vue?vue&type=style&index=0&id=f020c9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f020c9dc",
  null
  
)

export default component.exports